<template>
<div class="add-customer-window">
  <el-dialog title="添加客户" :close-on-click-modal="false" :visible.sync="dialogTableVisible_1" width="1000px">
    <el-descriptions size="mini" :column="1" border direction="vertical">
      <el-descriptions-item label="新增个人客户">
        <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
          <el-descriptions-item label="所属组织">
            <el-select size="mini" v-model="form_1.organization_project_id" clearable filterable placeholder="所属组织">
              <el-option
                v-for="item in project_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="descriptions-label-class" label="个人客户名称">
            <el-autocomplete
              class="w-500"
              v-model="form_1.name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入姓名"
              @select="handleSelect"
            ></el-autocomplete>
          </el-descriptions-item>
          <el-descriptions-item label="手机">
            <el-input size="mini" v-model="form_1.contact_number" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="家庭电话">
            <el-input size="mini" v-model="form_1.emergency_number" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="证件类型">
            <el-select size="mini" v-model="form_1.credentials_type" placeholder="请选择" class="w-200">
              <el-option
                v-for="item in credentialsList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="证件号码">
            <el-input size="mini" v-model="form_1.credentials_code" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户类型">
            <el-checkbox-group size="mini" v-model="form_1.user_type" >
              <el-checkbox label="1">业主</el-checkbox>
              <el-checkbox label="2">租户</el-checkbox>
              <el-checkbox label="3">住户</el-checkbox>
              <el-checkbox label="4">共有人</el-checkbox>
              <el-checkbox label="5">开发商</el-checkbox>
              <el-checkbox label="9">其它</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
    <div style="text-align: center;margin-top: 10px;">
      <el-button @click="dialogTableVisible_1=false" size="mini">取消</el-button>
      <el-button @click="submit" size="mini">{{(form_1.id)?'选择':'保存'}}</el-button>
    </div>
  </el-dialog>
  <el-dialog title="添加客户" :close-on-click-modal="false" :visible.sync="dialogTableVisible_2" width="1000px">
    <el-descriptions size="mini" :column="1" border direction="vertical">
      <el-descriptions-item label="新增企业客户">
        <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
          <el-descriptions-item label="所属组织">
            <el-select size="mini" v-model="form_2.organization_project_id" clearable filterable placeholder="所属组织">
              <el-option
                v-for="item in project_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="descriptions-label-class" label="企业客户名称">
            <el-autocomplete
              class="w-500"
              v-model="form_2.name"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入姓名"
              @select="handleSelect"
            ></el-autocomplete>
          </el-descriptions-item>
          <el-descriptions-item label="联系人">
            <el-input size="mini" v-model="form_2.contact_name" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <el-input size="mini" v-model="form_2.contact_number" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="移动电话">
            <el-input size="mini" v-model="form_2.phone_number" class="w-200"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户类型">
            <el-checkbox-group size="mini" v-model="form_2.user_type" >
              <el-checkbox label="1">业主</el-checkbox>
              <el-checkbox label="2">租户</el-checkbox>
              <el-checkbox label="3">住户</el-checkbox>
              <el-checkbox label="4">共有人</el-checkbox>
              <el-checkbox label="5">开发商</el-checkbox>
              <el-checkbox label="9">其它</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
    <div style="text-align: center;margin-top: 10px;">
      <el-button @click="dialogTableVisible_2=false" size="mini">取消</el-button>
      <el-button @click="submit" size="mini">{{(form_2.id)?'选择':'保存'}}</el-button>
    </div>
  </el-dialog>



</div>
</template>

<script>
export default {
  name: "AddCustomerWindow",
  data(){
    return{
      fm_type:0,
      dialogTableVisible_1:false,
      form_1:{
        name:"",
        organization:"",
        organization_project_id:"",
        contact_number:"",
        emergency_number:"",
        credentials_type:"",
        credentials_code:"",
        user_type:[]
      },
      dialogTableVisible_2:false,
      form_2:{
        name:"",
        organization:"",
        organization_project_id:"",
        contact_name:"",
        contact_number:"",
        phone_number:"",
        user_type:[]
      },
      credentialsList: [{"value":"1","label":"居民身份证"},{"value":"11","label":"离休干部荣誉证"},{"value":"12","label":"护照"},{"value":"9","label":"文职干部证"},{"value":"6","label":"士兵证"},{"value":"8","label":"军官退休证"},{"value":"2","label":"临时身份证"},{"value":"15","label":"外国人永久居留证"},{"value":"16","label":"其他"},{"value":"13","label":"港澳台同胞来往通行证"},{"value":"10","label":"文职干部退休证"},{"value":"3","label":"户口簿"},{"value":"4","label":"军官证"},{"value":"5","label":"警官证"},{"value":"7","label":"军事学院证"},{"value":"14","label":"边民出入境通行证"},{"value":"17","label":"居民身份证（台）"}],
      callback:null,
      project_list:[]
    }
  },
  methods:{
    show(type=1,callback){
      this.callback=callback;
      this.fm_type=type;
      this.project_list.length===0&&this.getProjectList();
      type===1?(this.dialogTableVisible_1=true):(this.dialogTableVisible_2=true);
    },
    submit(){
      const that = this;
      let from_data=JSON.parse(JSON.stringify(that.fm_type===1?that.form_1:that.form_2))
      if(!from_data.organization_project_id){
        window.alert("请选择归属组织（项目）");
        return false;
      }
      from_data.type=that.fm_type;
      if(from_data.id){
        from_data.customer_id=from_data.id;
        typeof that.callback==="function"&&(that.callback(from_data))
        that.callback=undefined;
        that.fm_type===1?(this.dialogTableVisible_1=false):(this.dialogTableVisible_2=false);
        that.form_1={
          name:"",
          organization:"",
          organization_project_id:"",
          contact_number:"",
          emergency_number:"",
          credentials_type:"",
          credentials_code:"",
          user_type:[]
        }
        that.form_2={
          name:"",
          organization:"",
          organization_project_id:"",
          contact_name:"",
          contact_number:"",
          phone_number:"",
          user_type:[]
        }
      }else {
        from_data.user_type=from_data.user_type.join(',');
        ERP.postRequest({url:"admin/Customer/saveCustomerBase",data:from_data},ret=>{
          if(ret.code){
            that.$msgbox.alert(ret.msg||"修改成功")
            typeof that.callback==="function"&&(that.callback(ret.data))
            that.callback=undefined;
            that.fm_type===1?(this.dialogTableVisible_1=false):(this.dialogTableVisible_2=false);
            that.form_1={
              name:"",
              organization:"",
              organization_project_id:"",
              contact_number:"",
              emergency_number:"",
              credentials_type:"",
              credentials_code:"",
              user_type:[]
            }
            that.form_2={
              name:"",
              organization:"",
              organization_project_id:"",
              contact_name:"",
              contact_number:"",
              phone_number:"",
              user_type:[]
            }
          }else{
            that.$msgbox.alert(ret.msg||"修改失败")
          }
        })
      }

    },
    querySearchAsync(queryString, cb) {
      const that = this;
      that.form_1.id=undefined
      that.form_2.id=undefined
      if(!queryString){
        cb([])
        return false
      }
      let from_data={}
      from_data.key_name=queryString;
      from_data.organization_project_id=that.fm_type===1?that.form_1.organization_project_id:that.form_2.organization_project_id;
      ERP.getRequest({url:"admin/Customer/getCustomerList",data:from_data},res=>{
        if (res.code) {
          cb(res.data.map(ret=>{return {
            value:`${ret.name}-[${ret.credentials_code}]-【${(ret.house_list.map(re=>re.address).join(','))}】`,//
            id:ret.id,
            data:ret
          }}));
        }
      })
    },
    handleSelect(item) {
      console.log(item)
      const that = this;
      if(that.fm_type===1){
        that.form_1={
          ...that.form_1,
          id:item.data.id,
          name:item.data.name,
          organization:item.data.organization,
          organization_project_id:item.data.organization_project_id,
          contact_number:item.data.contact_number,
          credentials_code:item.data.credentials_code,
          user_type:item.data.type?item.data.type.split(','):[]
        }
      }else {
        that.form_2={
          ...that.form_2,
          id:item.data.id,
          name:item.data.name,
          organization:item.data.organization,
          organization_project_id:item.data.organization_project_id,
          contact_number:item.data.contact_number,
          user_type:item.data.type?item.data.type.split(','):[]
        }
      }
      that.$forceUpdate()
    },
    getProjectList(){
      const that=this;
      ERP.getRequest({
        url:"admin/Project/getProjectList",
        data:{}
      },ret=>{
        if(ret.code){
          that.project_list=ret.data;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-customer-window{
  /deep/.el-dialog{
    //.el-dialog__wrapper{
    //   max-width: 1200px;
    //}
    .el-dialog__body{
      padding-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/AddCustomerWindow.vue